/**
 * Rótulos e cores dos status de inscrição numa sequência de follow-up.
 *
 * Vale para `account_contact_follow_up_states.status`. Antes esta tabela estava
 * duplicada literalmente na tela de Contatos e no monitor de Follow-ups; com a
 * inclusão manual pelo chat virariam três cópias.
 *
 * A tabela é montada na importação, antes de o idioma da conta ser conhecido, então
 * carrega `labelKey` em vez do texto — mesmo padrão da navegação e dos filtros de
 * data do CRM. Quem renderiza resolve a chave.
 */
export const FOLLOW_UP_STATUS_LABELS: Record<string, { labelKey: string; className: string }> = {
  active: {
    labelKey: "common:followUpStatus.active",
    className: "bg-[#DBEAFE] text-[#2563EB] dark:bg-blue-500/20 dark:text-[#60A5FA]",
  },
  paused: {
    labelKey: "common:followUpStatus.paused",
    className: "bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-400",
  },
  blocked: {
    labelKey: "common:followUpStatus.blocked",
    className: "bg-slate-100 text-slate-600 dark:bg-neutral-500/15 dark:text-neutral-300",
  },
  goal_met: {
    labelKey: "common:followUpStatus.goal_met",
    className: "bg-green-100 text-green-700 dark:bg-green-500/15 dark:text-green-400",
  },
  completed: {
    labelKey: "common:followUpStatus.completed",
    className: "bg-slate-100 text-slate-600 dark:bg-neutral-500/15 dark:text-neutral-300",
  },
  stopped: {
    labelKey: "common:followUpStatus.stopped",
    className: "bg-red-100 text-red-600 dark:bg-red-500/15 dark:text-red-400",
  },
};

/**
 * Um contato segurado pela guarda de intenção continua `active` no banco: marcar
 * 'paused' seria desfeito pela despausa genérica do bloco 2.8 do motor no minuto
 * seguinte. Para quem olha a tela, porém, ele ESTÁ pausado — o disparo não vai
 * acontecer até a hora marcada. Estas duas funções fazem essa tradução, e existem
 * aqui para o monitor e o painel do chat contarem a mesma história.
 */
export function isIntentHeld(state: {
  intent_hold_until?: string | null;
}): boolean {
  if (!state.intent_hold_until) return false;
  return new Date(state.intent_hold_until).getTime() > Date.now();
}

/** Status a EXIBIR — não o do banco. */
export function displayFollowUpStatus(state: {
  status: string;
  intent_hold_until?: string | null;
}): string {
  if (state.status === "active" && isIntentHeld(state)) return "paused";
  return state.status;
}

/** Status em que a cadência ainda pode voltar a disparar sozinha. */
export const FOLLOW_UP_LIVE_STATUSES = ["active", "paused", "blocked"] as const;

export function isFollowUpStateLive(status: string | null | undefined): boolean {
  return FOLLOW_UP_LIVE_STATUSES.includes(status as (typeof FOLLOW_UP_LIVE_STATUSES)[number]);
}
